<template>
  <div class="container" ref="container">
    <!-- 主表详细区域 -->
    <template v-if="isDetails()">
      <div>检查概览</div>
      <MianDetail :key="tableLoading" :detailForm="detailForm" />
    </template>
    <div>检查项详情</div>
    <div class="app-container">
      <!-- 左侧菜单区域 -->
      <div class="left-area">
        <div class="sidebar-header">
          <h2>安全检查项</h2>
        </div>
        <!-- 自定义菜单列表 -->
        <div class="menu-list">
          <div class="menu-item" v-for="(item, index) in menuItems" :key="index" @click="handleMenuClick(index)" :class="{ active: activeMenuIndex === index }">
            <span class="menu-text">{{ item.itemName }}</span>
            <span class="menu-badge">{{ item.solveCount }}/{{ item.totalCount }}</span>
          </div>
        </div>
      </div>
      <!-- 右侧主内容区域 -->
      <div class="right-area" :class="isDetails()?'table-details':''">
        <header class="main-header">
          <h1>{{activeMenuIndex+1}}. {{ activeMenuValue.itemName }}</h1>
          <el-tag type="info">涉及 {{ activeMenuValue.checkTotalCount }} 个区域</el-tag>
        </header>
        <div class="main-content">
          <!-- 检查标准和参考法规 -->
          <div class="check-standard">
            <h4>检查标准</h4>
            <p>{{ activeMenuValue.checkListStandard }} </p>
          </div>
          <!-- 统计卡片 -->
          <el-row :gutter="20" class="stat-row">
            <el-col :span="8">
              <el-card class="stat-card">
                <div class="card-content">
                  <el-tag type="success">符合</el-tag>
                  <p>{{ activeMenuValue.accordCount }} 个区域</p>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="stat-card">
                <div class="card-content">
                  <el-tag type="danger">不符合</el-tag>
                  <p>{{ activeMenuValue.unAccordCount }} 个区域</p>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="stat-card">
                <div class="card-content">
                  <el-tag type="info">不适用</el-tag>
                  <p>{{ activeMenuValue.unApplayCount }} 个区域</p>
                </div>
              </el-card>
            </el-col>
          </el-row>
          <!-- 区域检查表 -->
          <div class="region-table" v-loading="tableLoading">
            <h3>区域检查表 -{{ activeMenuValue.itemName }}</h3>

            <FormTable ref="formTable" :formData="menuItems[activeMenuIndex]" :optionConfig="optionConfig" />
          </div>
        </div>
      </div>
    </div>

    <related-information :detailForm="detailForm" v-if="detailForm.id"/>
    <span slot="dialog_footer" class="dialog-footer" v-if="!isDetails()">
      <el-button icon="el-icon-circle-plus-outline" type="primary" @click="submitForm()" :disabled="loading">提交</el-button>
      <el-button icon="el-icon-circle-close" @click="$emit('handleClose')" :disabled="loading">取消</el-button>
    </span>
  </div>
</template>

<script>
import MianDetail from "./mian-detail.vue";
import { updateSub, getCheckExecutel, updateMainCheck, getRecordDetail } from "../api";
import { disposeDetail, showItem } from '@/basic-common/util/common.js';
import RelatedInformation from "./related-information.vue";

export default {
  props: {
    transmitData: {
      required: true,
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  components: {
    MianDetail,
    RelatedInformation
  },
  data () {
    return {
      tableLoading: false,
      itemForm: { list: [] },
      menuItems: [],
      activeMenuIndex: 0,
      activeMenuValue: {},
      detailForm: {},
      formData: {},
      optionConfig: {
        columnType: this.transmitData.type,
        addBtn: false,
        delBtn: false,
        align: 'center',
        height: '50vh',
        menuButton: {
          text: '保存',
          callBack: ({ row, $index }) => {
            const validateKey = ['checkResult']
            const hasEmptyField = validateKey.some(key => {
              const value = row[key];
              return value === undefined || value === null || (typeof value === 'string' && value.trim() === '');
            });
            if (hasEmptyField) {
              this.$message.error(`第${$index + 1}行中，${validateKey.join('、')}存在未填写的字段`)
              console.log(`第${$index + 1}行中，${validateKey.join('、')}存在未填写的字段`);
              return; // 若有字段无值，不执行updateSub，直接返回
            }
            updateSub(row).then(() => {
              this.$message.success('操作成功')
              this.init()
              this.$emit('updateSub')
            })
          }
        },
        column: [
          {
            label: '检查区域',
            prop: 'areaName',
            required: true,
            disabled: true,
          },
          {
            label: '检查结果',
            prop: 'checkResult',
            required: true,
            dicData: this.$store.getters.commonDict['area_name'],
            type: "select",
          },
          {
            label: '现场照片',
            prop: 'checkPhotos',
            type: 'updata-img',
            url: '/api/produce/file-upload/uploadCheckPhoto'
          },
          {
            label: "问题描述",
            prop: "problemDescription",
            type: 'textarea',
            maxlength: 200,
            // required: true,
            span: 24,
            minRows: 3,
          },
        ]
      }
    };
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      const { id, type } = this.transmitData
      this.tableLoading = true

      const apiKey = {
        view: getRecordDetail,
        add: getCheckExecutel,
      }

      apiKey[type](id).then(({ data }) => {
        this.menuItems = data.data.list;
        this.detailForm = data.data;
        this.menuItems.forEach((item) => {
          this.$set(item, 'list', item.subList)
        })
        if (!Object.keys(this.activeMenuValue).length && this.menuItems.length) {
          this.activeMenuValue = this.menuItems[0]
        }
        this.isDetails() && disposeDetail(this.$refs.container, 'table-details')
      }).finally(() => {
        this.tableLoading = false
      })
    },
    // 是否是详情
    isDetails () {
      return this.transmitData.type && this.transmitData.type == 'view'
    },
    handleMenuClick (index) {
      console.log(this.menuItems[index]);
      this.activeMenuIndex = index;
      this.activeMenuValue = this.menuItems[index]
    },
    regionsNumber () {
      const item = this.menuItems[this.activeMenuIndex]
      return item && item.list ? item.list.length : 0
    },
    submitForm () {
      const submitList = this.menuItems.flatMap(item => item.list);
      updateMainCheck({ ...this.detailForm, list: submitList }).then(({ data }) => {
        if (data.code === 200) {
          this.$message.success(data.msg)
        }
        this.$emit('handleClose', true)
      })
    }
  }
};
</script>

<style lang="scss" scoped>
// 变量定义
$sidebar-width: 220px;
$primary-color: #3498db;
$sidebar-bg: #f8fcff;
$text-color: #3e3e3e;
$light-bg: #f1f1f1;
$card-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
$spacing: 15px;
// 混入定义
@mixin card-style {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: $card-shadow;
  padding: 20px;
}
// 核心布局
.app-container {
  display: flex;
  height: 100vh;
  overflow: hidden;
  width: 100%;

  // 左侧区域
  .left-area {
    width: $sidebar-width;
    background-color: $sidebar-bg;
    color: #717171;
    display: flex;
    flex-direction: column;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
    .sidebar-header {
      padding: 18px 20px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      h2 {
        margin: 0;
        font-size: 16px;
        text-align: center;
      }
    }
    .menu-list {
      flex: 1;
      overflow-y: hide;
      padding-top: 10px;
      .menu-item {
        padding: 14px 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: all 0.3s ease;
        position: relative;

        &:hover {
          background-color: rgba(255, 255, 255, 0.1);
        }

        &.active {
          background-color: $primary-color;

          &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 4px;
            background-color: #f1c40f;
          }
          .menu-badge {
            background-color: #6a96ed !important;
            color: #fcfcfc !important;
          }
        }
        .menu-text {
          flex: 1;
          font-size: 14px;
        }
        .menu-badge {
          display: inline-block;
          width: 40px;
          height: 25px;
          line-height: 25px;
          text-align: center;
          background-color: #e5e7eb;
          border-radius: 12px;
          color: #000;
        }
      }
    }
  }
  // 右侧区域
  .right-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: $light-bg;
    overflow: hidden;
    height: 100%;
    .main-header {
      padding: 0 $spacing;
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #e6e6e6;
      background-color: #fff;
      h1 {
        font-size: 18px;
        margin: 0;
      }
    }
    .main-content {
      flex: 1;
      padding: $spacing;
      padding-top: 5px;
      overflow-y: auto;
      height: 100%;
      .check-standard {
        font-size: 16px;
        margin: 0 0 12px 0;
        color: #333;
        font-weight: 500;
      }
      .stat-row {
        margin-bottom: $spacing;
        .stat-card {
          @include card-style;
          padding: 0px !important;
          border: none;
          text-align: center;
          .card-content {
            p {
              margin: 6px 0 0 0;
              font-size: 16px;
              color: $text-color;
            }
          }
          ::v-deep .el-card__body {
            padding: 5px !important;
          }
        }
      }
      .region-table {
        @include card-style;
        h3 {
          font-size: 16px;
          margin: 0 0 15px 0;
          color: #333;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
